import React from 'react';
import { RESOURCE_GROUPS } from '../data/resources';
import './ResourceHub.css';

/**
 * ResourceHub — zone 4: the curated resource hub + E-E-A-T anchor.
 *
 * Sits just above the footer. Links out to recognized authorities (CDC, AAP,
 * NAEYC…) and states plainly what Stratos is and isn't. This is what keeps the
 * whole site in the "Achievement Registry" lane instead of the YMYL
 * child-health lane. Do not replace these with commercial links.
 */
export default function ResourceHub() {
  return (
    <section className="resource-hub" aria-labelledby="resource-hub-title">
      <div className="container">
        <div className="rhub-head">
          <p className="eyebrow">Trusted Resources</p>
          <h2 id="resource-hub-title" className="section-title">Parent Resource Hub</h2>
          <p className="rhub-intro">
            Stratos Standard recognizes and records what your child can already do. For
            everything about how children grow, learn, and thrive, we point you to the
            authorities who do that work best.
          </p>
        </div>

        <div className="rhub-grid">
          {RESOURCE_GROUPS.map((group) => (
            <div key={group.id} className="rhub-col">
              <h3 className="rhub-col-title">{group.label}</h3>
              <p className="rhub-col-blurb">{group.blurb}</p>
              <ul className="rhub-links">
                {group.links.map((link) => (
                  <li key={link.href}>
                    <a
                      href={link.href}
                      target="_blank"
                      rel="noopener noreferrer nofollow"
                      className="rhub-link"
                    >
                      <span className="rhub-link-title">{link.title}</span>
                      <span className="rhub-link-source">{link.source}</span>
                      <span className="rhub-link-desc">{link.desc}</span>
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* E-E-A-T / non-diagnostic anchor — the explicit YMYL safe-zone statement. */}
        <div className="rhub-disclaimer" role="note">
          <h3>About the Stratos Standard registry</h3>
          <p>
            Stratos Standard is a celebration and recognition program. Our play-based
            verification sessions confirm and record achievements a child can already
            demonstrate, and each result becomes a permanent, searchable registry entry.
            We are <strong>not</strong> a medical, diagnostic, developmental-screening, or
            therapeutic service, and nothing here is medical or developmental advice. If
            you have any concern about your child’s development, please talk with your
            pediatrician or your state’s early-intervention program using the trusted
            resources above.
          </p>
        </div>
      </div>
    </section>
  );
}
